(function () {
	let hasShownRegionalPopup = false;
	const activePopups = [];

	const DACH_POPUP_ID = Number.parseInt(window.POPUP_IDS.dach);
	const ISRAEL_POPUP_ID = Number.parseInt(window.POPUP_IDS.israel);
	const SPAIN_POPUP_ID = Number.parseInt(window.POPUP_IDS.spain);
	const PORTUGAL_POPUP_ID = Number.parseInt(window.POPUP_IDS.portugal);

	let country = null;

	getCountry()
		.then((detectedCountry) => {
			country = detectedCountry;
			console.log('Detected Country: ' + country);
		});

	jQuery(document).on('elementor/popup/show', (e, id, instance) => {
		showPopupBasedOnCountry(id, instance);
	});

	/*
	 * Functions
	 */

	function showPopupBasedOnCountry(popupId, popupInstance) {
		// Make sure country is detected and RegionPopupName contains ID of the popup.
		if (!country) {
			setTimeout(() => showPopupBasedOnCountry(popupId, popupInstance), 1000);
		}

		console.log('Popup ID: ' + popupId, 'Country: ' + country);

		const REGIONAL_POPUPS = {
			[PORTUGAL_POPUP_ID]: ['Portugal'],
			[SPAIN_POPUP_ID]: ['Spain'],
			[DACH_POPUP_ID]: ['Germany', 'Austria', 'Switzerland'],
			[ISRAEL_POPUP_ID]: ['Israel']
		};

		if (REGIONAL_POPUPS.hasOwnProperty(popupId)) {
			if (!REGIONAL_POPUPS[popupId].includes(country)) { // Regional Popup not belong to your location.
				popupInstance.getModal().hide();
			} else {
				hasShownRegionalPopup = true;
				activePopups.forEach((popup) => popup.getModal().hide());
			}
		} else {
			if (hasShownRegionalPopup) {
				popupInstance.getModal().hide();
			} else {
				activePopups.push(popupInstance);
			}
		}
	}

})();
